import { publicRequest } from "../../requestMethod";


export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const PROFILELOAD_SUCCESS = 'PROFILELOAD_SUCCESS';

export function receiveLogin() {
  return {
    type: LOGIN_SUCCESS
  };
}

function loginError(payload) {
  return {
    type: LOGIN_FAILURE,
    payload,
  };
}

function requestLogout() {
  return {
    type: LOGOUT_REQUEST,
  };
}

export function receiveLogout() {
  return {
    type: LOGOUT_SUCCESS,
  };
}

// logs the user out
export function logoutUser() {
  return (dispatch) => {
    dispatch(requestLogout());
    localStorage.removeItem('authenticated');
    localStorage.removeItem('token');
    dispatch(receiveLogout());
  };
}

export function loginUser(creds,payload) {
 
  return async (dispatch) => {
    try{
      const {data}= await publicRequest.post(`/api/user/login`, creds)
    
      await localStorage.setItem('authenticated', true)
      await localStorage.setItem('token', data.token)
      dispatch(receiveLogin());
      // dispatch({type: PROFILELOAD_SUCCESS, payload: data});
      // toast.success('Login successfull')
      // payload.go(0);
     
      // payload.push('/')
return true
    }catch{
      // console.log('error');
      dispatch(loginError('Something was wrong. Try again'));
      // toast.error('wrong email or password')
    }
  }
}


export function registerUser(payload) {

  return async (dispatch) => {
    const {data}= await publicRequest.post(`/api/user`, payload.creds)
  
   if (data) {
    
    
    // dispatch({type: REGISTER_SUCCESS_PROFILELOAD, payload: data});
    payload.history.push('/login');
    }else{
      alert('problem creating account')
    }
    
  }
}
